import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import CartPage from 'features/cart/CartPage';
import OrderHistory from './pages/OrderHistory/OrderHistory';

const HomePage = React.lazy(() => import('./pages/Home/HomePage'));
const RewardsPage = React.lazy(() => import('./pages/Rewards/Rewards'));
const AddInformationPage = React.lazy(() => import('features/payment/AddInformationPage'));
const ItemDetailPage = React.lazy(() => import('./pages/ItemDetail/ItemDetailPage'));
const OrderHistoryPage = React.lazy(() => import('features/home/pages/OrderHistory/OrderHistory'));
const PaymentAdyen = React.lazy(() => import('features/payment/components/PaymentAdyen'));
const TillPayment = React.lazy(() => import('features/payment/components/TillPayment'));

const HomeRoute = () => {
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}`} exact render={() => <HomePage />}></Route>
      <Route
        exact
        path={`${match.path}/check-new-order`}
        render={() => <OrderHistory isNewOrder={true} />}
      />
      <Route path={`${match.path}/rewards`} exact render={() => <RewardsPage />}></Route>
      <Route path={`${match.path}/cart`} render={() => <CartPage type="online" />} />
      <Route
        path={`${match.path}/add-information`}
        render={() => <AddInformationPage type="online" />}
      />
      <Route path={`${match.path}/:categoryId/:itemId`} render={() => <ItemDetailPage />} />
      <Route path={`${match.path}/order-history`} render={() => <OrderHistoryPage />} />
      <Route path={`${match.path}/payment-adyen`} render={() => <PaymentAdyen />} />
      <Route path={`${match.path}/payment`} render={() => <TillPayment />} />
    </Switch>
  );
};

export default HomeRoute;
